import { View } from 'react-native'
import { CarFront, HardHat, Tractor, Truck } from '@/components/ui/icons'
import type { ServiceCatalogEntry } from '@/lib/services/services-catalog'
import { useTheme } from '@/lib/hooks/use-theme'
import { RADIUS } from '@/lib/brand'
import { useSemanticColors } from '@/lib/theme/tokens'

const ICONS = {
  tow: CarFront,
  equipment: Tractor,
  construction: HardHat,
  materials: Truck,
} as const

const TONES = {
  tow: { fill: 'rgba(239,78,74,0.12)' },
  equipment: { fill: 'rgba(91,84,144,0.13)' },
  construction: { fill: 'rgba(242,180,65,0.18)' },
  materials: { fill: 'rgba(50,138,108,0.14)' },
} as const

export function ServiceCategoryIcon({
  category,
  size = 22,
}: {
  category: Pick<ServiceCatalogEntry, 'icon'>
  size?: number
}) {
  const { isDark } = useTheme()
  const colors = useSemanticColors(isDark)
  const Icon = ICONS[category.icon]
  const tone = TONES[category.icon]
  const iconColor = {
    tow: colors.textAccent,
    equipment: colors.textBrand,
    construction: colors.warning,
    materials: colors.success,
  }[category.icon]
  const box = size + 20
  return (
    <View
      style={{
        width: box,
        height: box,
        borderRadius: Math.min(RADIUS.lg, box / 2),
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: tone.fill,
      }}
    >
      <Icon size={size} color={iconColor} strokeWidth={1.9} />
    </View>
  )
}
